var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDayNight = function SvgDayNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m98.505 19.149-6.372-6.3L14.99 88.991l6.372 6.3zm1.07 35.527c-2.937 1.28-5.745 3.198-8.17 5.626-10.469 10.487-10.469 27.498 0 37.86 2.425 2.429 5.238 4.347 8.17 5.626-9.83 4.222-21.576 2.428-29.622-5.625-10.47-10.487-10.47-27.499 0-37.861 8.046-8.054 19.792-9.847 29.623-5.626zm-65.689 2.071a16.873 16.873 0 0 1 0-23.932 16.873 16.873 0 0 1 23.932 0zM16.668 9.637l-5.96 5.96 14.38 14.383 5.962-5.961zM.755 37.474 0 45.405l19.588 1.706.755-7.93zm5.67 30.728 4.8 6.746 16.613-11.455-4.8-6.747zM45.404 0l-7.93.755 1.706 19.588 7.93-.755zM76.02 10.154l-7.144-4.8-12.129 16.613 7.144 4.8z"
  })));
};

export default SvgDayNight;